import type { ClickReleaseConfig } from '../config/types';
import { cssVarsFromConfig } from './vars';

/**
 * Apply the theme to the shadow host element: set the theme mode (light/dark/auto — the base
 * stylesheet keys dark palettes off `:host([data-theme='dark'])` and the `auto` media query) and
 * write the client's compiled color knobs as CSS custom properties on the host.
 */
export function applyTheme(hostEl: HTMLElement, config: ClickReleaseConfig): void {
  hostEl.dataset.theme = config.theme.mode;
  for (const [name, value] of Object.entries(cssVarsFromConfig(config))) {
    hostEl.style.setProperty(name, value);
  }
}

/** Toggle reduced-motion mode on the host; the base stylesheet disables transitions when set. */
export function applyMotion(hostEl: HTMLElement, reduced: boolean): void {
  hostEl.dataset.motion = reduced ? 'reduced' : 'full';
}
